import { render, staticRenderFns } from "./SurgeonSearchIndex.vue?vue&type=template&id=0bc3a949"
import script from "./SurgeonSearchIndex.vue?vue&type=script&lang=js"
export * from "./SurgeonSearchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports